export default __webpack_public_path__ + "static/media/profile.7e04fe71.jpg";